<div class="card-design-container">
    <div class="category-tabs-wrapper">
        <div class="category-tabs">
            <button *ngFor="let c of Card_Image_Name" mat-raised-button
                [class.active]="selectedCategory == c.category_id" (click)="handleCategorySwitch(c)">
                <mat-icon>category</mat-icon>
                <span>{{ c.category }}</span>
            </button>
        </div>
    </div>

    <div class="content-wrapper">
        <div class="preview-panel">
            <div class="panel-header">
                <mat-icon>visibility</mat-icon>
                <h3>Card Preview</h3>
            </div>

            <div class="card-preview-container" #previewContainer>
                <div class="preview-workspace">
                    <div class="preview-stats">
                        <div class="preview-chip">
                            <mat-icon>straighten</mat-icon>
                            <span>{{ pixelSizeLabel }}</span>
                        </div>

                        <div class="preview-chip">
                            <mat-icon>local_printshop</mat-icon>
                            <span>{{ printSizeLabel }}</span>
                        </div>

                        <div class="preview-chip" *ngIf="previewScale < 1">
                            <mat-icon>fit_screen</mat-icon>
                            <span>{{ previewScaleLabel }}</span>
                        </div>

                        <div class="preview-chip quality-chip" [ngClass]="printQualityClass">
                            <mat-icon>verified</mat-icon>
                            <span>{{ printQualityLabel }}</span>
                        </div>
                    </div>

                    <div class="quality-note">
                        {{ printQualityHint }}
                    </div>

                    <!-- <div class="preview-note">
	                        Preview follows the card-generation API rules: the background is width-fitted from the top, text uses fixed generator offsets, and clipping matches the final PNG.
	                    </div> -->

                    <div class="preview-warning" *ngIf="previewLayoutWarning">
                        <mat-icon>warning_amber</mat-icon>
                        <span>{{ previewLayoutWarning }}</span>
                    </div>

                    <div class="preview-stage" [style.width.px]="previewCardWidth"
                        [style.height.px]="previewCardHeight">
                        <div class="card preview-card" [style.width.px]="cardWidth" [style.height.px]="cardHeight"
                            [style.transform]="previewTransform">
                            <div *ngIf="image1; else emptyCard" class="card-image-background">
                                <img [src]="'https://aieventzo.com/upload/icard/' + image1" alt="Card background"
                                    (load)="adjustCardSize($event)">
                            </div>

                            <ng-template #emptyCard>
                                <div class="card-image-placeholder">
                                    <mat-icon>image</mat-icon>
                                    <span>Upload a card background to preview the final print layout.</span>
                                </div>
                            </ng-template>

                            <div class="generator-overlay" *ngIf="content !== 'no'" [style.color]="color">
                                <div class="scan-box" [style.left.px]="cardX" [style.top.px]="cardY"
                                    [style.width.px]="previewScanWidth" [style.height.px]="previewScanHeight">
                                    <img [src]="scan_type === 'qrcode' ? './assets/qrcode.png' : './assets/barcode.png'"
                                        alt="Scanner Image" />
                                </div>

                                <div class="preview-text preview-text-horizontal" *ngIf="layout === 'horizontal'"
                                    [style.left.px]="previewHorizontalTextX" [style.top.px]="cardY"
                                    [style.font-size.px]="font_size">
                                    <div *ngFor="let line of previewTextLines; let first = first" class="preview-line"
                                        [class.first-line]="first">
                                        {{ line }}
                                    </div>
                                </div>

                                <div class="preview-text preview-text-vertical" *ngIf="layout === 'vertical'"
                                    [style.left.px]="previewVerticalTextCenterX" [style.top.px]="previewVerticalTextTop"
                                    [style.font-size.px]="font_size">
                                    <div *ngFor="let line of previewTextLines; let first = first" class="preview-line"
                                        [class.first-line]="first">
                                        {{ line }}
                                    </div>
                                </div>
                            </div>

                            <div class="footer-strip" *ngIf="company_ad === 'on'" [style.height.px]="footerHeight">
                                <span>{{ company_ad_text }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="config-panel">
            <mat-card class="config-card">
                <mat-card-content>
                    <div class="config-section">
                        <div class="section-header">
                            <mat-icon>photo_library</mat-icon>
                            <h4>Card Background Image</h4>
                        </div>

                        <div class="image-upload">
                            <ngx-file-drop [dropZoneLabel]="'Drag and drop files here'"
                                (onFileDrop)="onFileDrop($event,'Commercial_Invoice')" dropZoneClassName="drop-zone"
                                contentClassName="drop-content">
                                <ng-template ngx-file-drop-content-tmp let-openFileSelector="openFileSelector">
                                    <mat-icon>cloud_upload</mat-icon>
                                    <p><a type="button" (click)="commercial_invoice.click()">Click to upload</a></p>
                                    <span class="file-hint">Supported formats: JPG, PNG, JPEG</span>
                                </ng-template>
                            </ngx-file-drop>
                            <input type="file" class="form-control" #commercial_invoice accept=".jpg,.jpeg,.png"
                                (change)="previewpimage(commercial_invoice.files)" style="display: none;">
                        </div>
                    </div>

                    <mat-divider></mat-divider>

                    <div class="config-section">
                        <div class="section-header">
                            <mat-icon>aspect_ratio</mat-icon>
                            <h4>Card Dimensions</h4>
                        </div>

                        <div class="size-tool-row">
                            <mat-form-field appearance="outline" class="form-field size-input-field">
                                <mat-label>Print Size</mat-label>
                                <input matInput [(ngModel)]="sizeInput" placeholder="1050 x 1650 or 3.5 x 5.5 in"
                                    (keyup.enter)="applySizeInput()">
                                <mat-icon matPrefix>crop_free</mat-icon>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="form-field unit-select-field">
                                <mat-label>Unit</mat-label>
                                <mat-select [(ngModel)]="sizeUnit" (selectionChange)="onSizeUnitChange()">
                                    <mat-option *ngFor="let unit of sizeUnits" [value]="unit.value">
                                        {{ unit.label }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>

                            <button mat-stroked-button type="button" class="apply-size-button"
                                (click)="applySizeInput()">
                                <mat-icon>check</mat-icon>
                                Apply
                            </button>
                        </div>

                        <div class="dimension-note">
                            Use values like 1050 x 1650, 88.9 x 139.7 mm, or 3.5 x 5.5 in. The preview auto-fits the
                            screen, but saved size stays exact at {{ printDpi }} DPI. Exact output: {{ pixelSizeLabel
                            }}.
                        </div>
                    </div>

                    <mat-divider></mat-divider>

                    <div class="radio-group-wrapper">
                        <label>Want Your Content in ID-Card?</label>
                        <mat-radio-group [(ngModel)]="content" (ngModelChange)="markUnsaved()">
                            <mat-radio-button value="yes">Yes</mat-radio-button>
                            <mat-radio-button value="no">No</mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <div class="radio-group-wrapper">
                        <label>Show ID in ID-Card?</label>
                        <mat-radio-group [(ngModel)]="show_id" (ngModelChange)="markUnsaved()">
                            <mat-radio-button value="yes">Yes</mat-radio-button>
                            <mat-radio-button value="no">No</mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <div class="radio-group-wrapper">
                        <label>Show QR Code in ID-Card?</label>
                        <mat-radio-group [(ngModel)]="show_qr" (ngModelChange)="markUnsaved()">
                            <mat-radio-button value="yes">Yes</mat-radio-button>
                            <mat-radio-button value="no">No</mat-radio-button>
                        </mat-radio-group>
                    </div>

                    <mat-divider *ngIf="content !== 'no'"></mat-divider>

                    <div class="config-section" *ngIf="content !== 'no'">
                        <div class="section-header">
                            <mat-icon>qr_code_2</mat-icon>
                            <h4>Scanner Configuration</h4>
                        </div>

                        <div class="radio-group-wrapper">
                            <label>Scanner Type</label>
                            <mat-radio-group [(ngModel)]="scan_type" (ngModelChange)="onScanTypeChange()">
                                <mat-radio-button value="qrcode">QR Code</mat-radio-button>
                                <mat-radio-button value="barcode">Barcode</mat-radio-button>
                            </mat-radio-group>
                        </div>

                        <div class="form-row">
                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>{{ scan_type }} Width</mat-label>
                                <input type="number" matInput [(ngModel)]="qr_width"
                                    (ngModelChange)="onQrWidthChange()">
                                <span matSuffix>px</span>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>{{ scan_type }} Height</mat-label>
                                <input type="number" matInput [(ngModel)]="qr_height"
                                    (ngModelChange)="onQrHeightChange()">
                                <span matSuffix>px</span>
                            </mat-form-field>
                        </div>
                    </div>

                    <mat-divider *ngIf="content !== 'no'"></mat-divider>

                    <div class="config-section" *ngIf="content !== 'no'">
                        <div class="section-header">
                            <mat-icon>palette</mat-icon>
                            <h4>Layout & Styling</h4>
                        </div>

                        <mat-form-field appearance="outline" class="form-field full-width">
                            <mat-label>Content Position from Left</mat-label>
                            <input type="number" matInput [(ngModel)]="cardX" (ngModelChange)="markUnsaved()">
                            <mat-icon matPrefix>arrow_back</mat-icon>
                            <span matSuffix>px</span>
                        </mat-form-field>

                        <mat-form-field appearance="outline" class="form-field full-width">
                            <mat-label>Content Position from Top</mat-label>
                            <input type="number" matInput [(ngModel)]="cardY" (ngModelChange)="markUnsaved()">
                            <mat-icon matPrefix>vertical_align_top</mat-icon>
                            <span matSuffix>px</span>
                        </mat-form-field>

                        <div class="radio-group-wrapper">
                            <label>Layout Orientation</label>
                            <mat-radio-group [(ngModel)]="layout" (ngModelChange)="markUnsaved()">
                                <mat-radio-button value="horizontal">
                                    <mat-icon>view_column</mat-icon> Horizontal
                                </mat-radio-button>
                                <mat-radio-button value="vertical">
                                    <mat-icon>view_agenda</mat-icon> Vertical
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>

                        <div class="form-row">
                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Font Size</mat-label>
                                <input type="number" matInput [(ngModel)]="font_size" (ngModelChange)="markUnsaved()">
                                <mat-icon matPrefix>format_size</mat-icon>
                                <span matSuffix>px</span>
                            </mat-form-field>

                            <mat-form-field appearance="outline" class="form-field">
                                <mat-label>Text Color</mat-label>
                                <input type="color" matInput [(ngModel)]="color" (ngModelChange)="markUnsaved()">
                                <mat-icon matPrefix>color_lens</mat-icon>
                            </mat-form-field>
                        </div>
                    </div>

                    <mat-divider></mat-divider>

                    <div class="config-section">
                        <div class="section-header">
                            <mat-icon>picture_as_pdf</mat-icon>
                            <h4>PDF Options</h4>
                        </div>

                        <div class="radio-group-wrapper">
                            <label>Print Background in PDF</label>
                            <mat-radio-group [(ngModel)]="pdf_bg" (ngModelChange)="markUnsaved()">
                                <mat-radio-button value="yes">Yes</mat-radio-button>
                                <mat-radio-button value="no">No</mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>

                    <mat-divider></mat-divider>

                    <div class="config-section">
                        <div class="section-header">
                            <mat-icon>campaign</mat-icon>
                            <h4>Company Advertisement</h4>
                        </div>

                        <div class="radio-group-wrapper">
                            <label>Show Company Ad</label>
                            <mat-radio-group [(ngModel)]="company_ad" (ngModelChange)="markUnsaved()"
                                [disabled]="!Enable_Editing">
                                <mat-radio-button value="on">On</mat-radio-button>
                                <mat-radio-button value="off">Off</mat-radio-button>
                            </mat-radio-group>
                        </div>

                        <mat-form-field appearance="outline" class="form-field full-width" *ngIf="company_ad === 'on'">
                            <mat-label>Advertisement Text</mat-label>
                            <input matInput [(ngModel)]="company_ad_text" (ngModelChange)="markUnsaved()"
                                [readonly]="!Enable_Editing">
                            <mat-icon matPrefix>text_fields</mat-icon>
                        </mat-form-field>
                    </div>
                </mat-card-content>

                <mat-card-actions align="end">
                    <button mat-raised-button color="primary" (click)="Update_Card()">
                        <mat-icon>save</mat-icon>
                        Save Changes
                    </button>
                </mat-card-actions>
            </mat-card>
        </div>
    </div>
</div>